import React, {useCallback, useEffect, useState} from 'react';
import PageLoaderComponent from "../page-loader/pageLoaderComponent";
import {CommonService} from "../../services";
import {Misc} from "../../../constants";
import {
    logout,
    setLoggedInUserData,
    setLoggedInUserToken,
    setUserSignature
} from "../../../store/actions/account.action";
import {useDispatch} from "react-redux";
import {IAPIResponseType} from "../../models/api.model";
import {setSelectedLab} from "../../../store/actions/selectedLab.action";

interface CheckLoginComponentProps {

}

const CheckLoginComponent = (props: React.PropsWithChildren<CheckLoginComponentProps>) => {

    const {children} = props;
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    const verifyUserSignature = useCallback((userId: string) => {
        CommonService._account.VerifySignature(userId).then((response: IAPIResponseType<any>) => {
            dispatch(setUserSignature(response.data));
        }).catch(() => {
            dispatch(setUserSignature(null));
        })
    }, [dispatch])

    const checkLogin = useCallback(() => {
        const token = CommonService._localStorage.getItem(Misc.LOCAL_STORAGE_JWT_TOKEN);
        if (token) {
            setIsLoading(true);
            CommonService._account.CheckLoginAPICall(token)
                .then((response: IAPIResponseType<any>) => {
                    dispatch(setLoggedInUserData(response.data));
                    dispatch(setLoggedInUserToken(token));
                    if (Object.keys(response?.data?.labDetails || {})?.length) {
                        dispatch(setSelectedLab(response?.data?.labDetails?.id))
                    }
                    setIsLoading(false);
                    setIsLoaded(true);
                    if (response?.data?.id) {
                        verifyUserSignature(response.data?.id)
                    } else {
                        CommonService._alert.showToast("User ID not found");
                    }
                })
                .catch(() => {
                    dispatch(logout());
                    setIsLoading(false);
                    setIsLoaded(true);
                })
        } else {
            setIsLoading(false);
            setIsLoaded(true);
        }
    }, [dispatch, verifyUserSignature]);

    useEffect(() => {
        checkLogin();
    }, [checkLogin]);

    return (
        <>
            {(isLoading && !isLoaded) && <PageLoaderComponent/>}
            {isLoaded && children}
        </>
    )
};

export default CheckLoginComponent;
